// https://developer.paypal.com/braintree/docs/guides/paypal/vault/javascript/v3

export async function loadPayPalCheckout({
  clientToken,
  heightSize = 50,
  buttonId,
  onComplete,
  onError,
  onLoadError,
  onCancel,
  onPaymentClick,
  onInit
}) {
  const { braintree } = window;

  try {
    braintree.client
      .create({
        authorization: clientToken
      })
      .then((clientInstance) => {
        return braintree.paypalCheckout.create({
          client: clientInstance
        });
      })
      .then((paypalCheckoutInstance) => {
        return paypalCheckoutInstance.loadPayPalSDK({
          vault: true
        });
      })
      .then((paypalCheckoutInstance) => {
        const { paypal } = window;
        return paypal
          .Buttons({
            style: {
              layout: "vertical",
              color: "white",
              shape: "rect",
              label: "paypal",
              height: heightSize // 50 is default
            },
            fundingSource: paypal.FUNDING.PAYPAL,
            createBillingAgreement: function () {
              return paypalCheckoutInstance.createPayment({
                flow: "vault", // Required
                billingAgreementDescription: "$39.00 Monthly"
              });
            },
            onInit: function (...args) {
              onInit(...args);
            },
            onClick: function (data) {
              onPaymentClick(data);
            },
            onApprove: function (braintreePaymentInfo) {
              return paypalCheckoutInstance
                .tokenizePayment(braintreePaymentInfo)
                .then((tokenizedPaymentData) => {
                  onComplete({
                    tokenizedPaymentData,
                    braintreePaymentInfo,
                    error: null
                  });
                })
                .catch((err) => {
                  onComplete({
                    error: err
                  });
                });
            },
            onCancel: function (data) {
              onCancel({
                data: data
              });
            },
            onError: function (err) {
              onError({
                error: err
              });
            }
          })
          .render(buttonId);
      })
      .catch((err) => {
        console.error(err);
        onLoadError({
          error: err
        });
      });
  } catch (err) {
    console.error(err);
    onLoadError({
      error: err
    });
  }
}
